import { windowEventsManager } from '@folklore/hooks';
import { SpringValue, useSpringValue } from '@react-spring/web';
import { useEffect, useState } from 'react';

// Window vertical scroll as a spring value, for animated styles: it follows the scroll
// without rendering the component.
export function useWindowScrollValue(): SpringValue<number> {
    const scrollValue = useSpringValue<number>(0, { immediate: true });

    useEffect(() => {
        function onScroll() {
            scrollValue.set(window.scrollY);
        }
        onScroll();
        windowEventsManager.subscribe('scroll', onScroll);
        return () => windowEventsManager.unsubscribe('scroll', onScroll);
    }, [scrollValue]);

    return scrollValue;
}

// Whether the window is scrolled past a threshold: only renders when that changes.
export function useWindowScrolledPast(threshold: number, { disabled = false } = {}): boolean {
    const [scrolledPast, setScrolledPast] = useState(false);

    useEffect(() => {
        if (disabled) {
            return () => {};
        }
        function onScroll() {
            setScrolledPast(window.scrollY > threshold);
        }
        onScroll();
        windowEventsManager.subscribe('scroll', onScroll);
        return () => windowEventsManager.unsubscribe('scroll', onScroll);
    }, [threshold, disabled]);

    return !disabled && scrolledPast;
}
